<template>
  <div class="anticon" :class="getAppLogoClass" @click="goHome">
    <img src="https://static.neolix.net/logo.png" class="logo" v-show="showTitle" />
    <img src="https://static.neolix.net/logo.png" class="logo collapse-logo" v-show="!showTitle" />
    <div class="truncate md:opacity-100" :class="getTitleClass" v-show="showTitle">{{ title }}</div>
  </div>
</template>
<script lang="ts" setup>
import { computed, unref } from 'vue'
import { useGlobSetting } from '/@/hooks/setting'
import { useGo } from '/@/hooks/web/usePage'
import { useMenuSetting } from '/@/hooks/setting/useMenuSetting'
import { useDesign } from '/@/hooks/web/useDesign'
import { PageEnum } from '/@/enums/pageEnum'
import { useUserStore } from '/@/store/modules/user'

const props = defineProps({
  /**
   * The theme of the current parent component
   */
  theme: { type: String, validator: (v: string) => ['light', 'dark'].includes(v) },
  /**
   * Whether to show title
   */
  showTitle: { type: Boolean, default: true },
  /**
   * The title is also displayed when the menu is collapsed
   */
  alwaysShowTitle: { type: Boolean },
})

const { prefixCls } = useDesign('app-logo')
const { getCollapsedShowTitle } = useMenuSetting()
const userStore = useUserStore()
const { title } = useGlobSetting()
const go = useGo()

const getAppLogoClass = computed(() => [
  prefixCls,
  props.theme,
  { 'collapsed-show-title': unref(getCollapsedShowTitle) },
])

const getTitleClass = computed(() => [
  `${prefixCls}__title`,
  {
    'xs:opacity-0': !props.alwaysShowTitle,
  },
])

function goHome() {
  go(userStore.getHomePath || PageEnum.BASE_HOME)
}
</script>
<style lang="less" scoped>
@prefix-cls: ~'@{namespace}-app-logo';

.@{prefix-cls} {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;

  .logo {
    max-width: none;
    margin-right: 12px;
    height: 16px;

    &.collapse-logo {
      position: relative;
      right: 4px;
      height: 36px;
      width: 36px;
      margin-right: 0;
    }
  }

  .divider {
    width: 2px;
    height: 16px;
    background: #d8d8d8;
    opacity: 0.5;
    margin: 0 10px;
  }

  &.light {
    // border-bottom: 1px solid @border-color-base;
  }

  &.collapsed-show-title {
    padding-left: 20px;
  }

  &.light &__title {
    color: @text-color;
  }

  &.dark &__title {
    color: @white;
  }

  &__title {
    font-size: 18px;
    font-weight: 700;
    transition: all 0.5s;
    line-height: normal;
  }
}
</style>
